import { Component, Input, OnInit } from '@angular/core';

import { Trend } from '../../../../../canvas/components/trends/trends/trend';
import { TrendsService } from '../../../../../canvas/components/trends/trends/trends.service';

@Component({
  selector: 'app-trend-scanning',
  templateUrl: './trend-scanning.component.html',
  styleUrls: ['./trend-scanning.component.css']
})
export class TrendScanningComponent implements OnInit {

  @Input() onShowPeriod;
  windowWith;
  trends: Trend [];
  mockTrends: Trend [] = [];

  constructor(
    private _trendsService: TrendsService) {}

  getTrends(): void {
    this._trendsService.getTrends().then(trends => this.trends = trends);
  }

  getMockTrends(): void {
    this._trendsService.getMockTrends().then(mockTrends => this.mockTrends = mockTrends);
  }

  ngOnInit(): void {
    this.windowWith = window.innerWidth;
    this.getMockTrends();
    this.getTrends();
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
  }

  breakRow(theArr: any[]) {
    const arrOfarr = [];
    if (this.windowWith > 480) {
      for (let i = 0; i < theArr.length ; i+=2) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 2; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else {
      for (let i = 0; i < theArr.length ; i+=1) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 1; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/tomorrow/components/trend-scanning/trend-scanning.component.ts